// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--c_JEK","content":"_6c97079b1b--content--Sdmah"};